import Vue from 'vue'
import ImagePic from './ImagePic'
import ImagePicVip from './ImagePicVip'
import BackTop from './BackTop'
import NavBar from './NavBar'
import IsEmpty from './IsEmpty'
// 注册一些常用的组件到全局
Vue.component('image-pic', ImagePic)
Vue.component('image-pic-vip', ImagePicVip)
Vue.component('back-top', BackTop)
Vue.component('nav-bar', NavBar)
Vue.component('is-empty', IsEmpty)
